import React, { useState } from "react";

const Tabs = ({ components, tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="tabs-component">
      <div className="flex justify-evenly w-full border-b tabs-header">
        {tabs?.map((tab, idx) => {
          return (
            <button
              key={idx}
              className={`tab-button w-full  py-2 px-4 focus:outline-none ${
                activeTab === idx
                  ? "border-blue-500 border-b-2 text-blue-500"
                  : ""
              }`}
              onClick={() => handleTabClick(idx)}
            >
              {tab}
            </button>
          );
        })}
      </div>
      <div className="tabs-content">
        {components?.map((Component, idx) => {
          return (
            <div
              key={idx}
              className={`tab-content pt-3 ${
                activeTab === idx ? "" : "hidden"
              }`}
              id={idx}
              style={{ display: activeTab === idx ? "block" : "none" }}
            >
              {Component}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
